import { Button, Link, VStack, Text, HStack } from '@chakra-ui/react';
import NextImage from 'shared/NextImage';

const TabButtonsList = ({ buttons, title = 'Присоединяйтесь!' }) => (
  <VStack align="flex-start" w="full" gap="0">
    <Text
      color="text.grayMagengo"
      fontSize={{ mobile: '12px', laptop: '16px' }}
      mt={{ mobile: '20px', tablet: '16px', laptop: '24px' }}
      mb={{ mobile: '12px', desktop: '16px' }}
    >
      {title}
    </Text>

    <HStack gap="8px" w="full" maxW={{ mobile: '308px', laptop: '336px' }}>
      {buttons.map(({ text, link, icon }) => (
        <Link key={text} href={link} flex="1" isExternal>
          <Button
            w="full"
            h="full"
            gap={{ mobile: '3px', tablet: '11px' }}
            p={{ mobile: '7.5px 23px', xxl: '16px 28px' }}
          >
            <NextImage
              src={icon}
              alt={`Логотип ${text}`}
              w={{ mobile: '21px', tablet: '22px', laptop: '25px' }}
              h="25px"
            />

            <Text fontSize={{ mobile: '14px', laptop: '16px' }}>{text}</Text>
          </Button>
        </Link>
      ))}
    </HStack>
  </VStack>
);

export default TabButtonsList;
